import { useEffect, useState } from 'react';
import { useMst } from '@trader/store';

export const useInternetStatus = () => {
  const store = useMst();
  const [isOnline, setIsOnline] = useState(true);

  const handleStatus = event => {
    setIsOnline(event.type === 'online');

    if (event.type !== 'online') {
      store.notifications.add({
        message: 'You are offline',
        options: {
          variant: 'warning',
          autoHideDuration: 2000,
        },
      });
    } else {
      window.location.reload();
    }
  };
  useEffect(() => {
    window.addEventListener('offline', handleStatus);
    window.addEventListener('online', handleStatus);

    return () => {
      window.removeEventListener('offline', handleStatus);
      window.removeEventListener('online', handleStatus);
    };
  });

  return isOnline;
};
